import React__default from 'react';
import classnames from 'classnames';
import classes from './index.module.scss.js';

// See https://github.mpi-internal.com/SCM-Italy/yams-image-rules to check which are the available Yams rules
const CONFIGURATION = new Map([
    ['108x82', 'card-mobile-new-small'],
    ['108x126', 'ad-promote-desktop-carousel'],
    ['121x82', 'card-desktop-carousel-mini'],
    ['120x120', 'card-desktop-large'],
    ['160x120', 'card-desktop-large'],
    ['200x126', 'ad-promote-desktop-unique'],
]);
const getSources = (baseSource, format) => {
    const rule = CONFIGURATION.get(format);
    return {
        src: `${baseSource}?rule=${rule}-1x-auto`,
        srcSet: `${baseSource}?rule=${rule}-1x-auto 1x, ${baseSource}?rule=${rule}-2x-auto 2x, ${baseSource}?rule=${rule}-3x-auto 3x`,
    };
};
const ItemPicture = ({ subject, categoryID, images, className, formats, assetsBase = 'https://assets.subito.it', }) => {
    const baseSource = images?.[0]?.cdnBaseUrl;
    return (React__default.createElement("div", { className: classnames(className, classes['container']) },
        React__default.createElement("figure", { className: classes['figure'] }, baseSource ? (React__default.createElement(AdPicture, { subject: subject, formats: formats, images: images })) : (React__default.createElement(Placeholder, { assetsBase: assetsBase, categoryID: categoryID, subject: subject }))),
        React__default.createElement(CounterWatermark, { assetsBase: assetsBase, images: images })));
};
const AdPicture = ({ subject, formats, images }) => {
    const baseSource = images?.[0]?.cdnBaseUrl;
    return (React__default.createElement(React__default.Fragment, null, formats.map((format) => (React__default.createElement("img", { key: format, className: classnames(classes['picture'], classes[`picture-${format}`]), alt: subject, loading: 'lazy', decoding: "async", ...getSources(baseSource, format) })))));
};
const Placeholder = ({ categoryID, subject, assetsBase }) => (React__default.createElement("img", { src: `${assetsBase}/static/icons/categories/${categoryID}.svg`, alt: subject, className: classes['placeholder'], loading: "lazy", decoding: "async" }));
const CounterWatermark = ({ images, assetsBase }) => {
    if (images?.length > 1) {
        return (React__default.createElement("div", { className: classes['count'] },
            React__default.createElement("img", { src: `${assetsBase}/static/icons/cactus/camera.svg`, alt: `Questo annuncio ha ${images?.length} immagini`, width: 16, height: 16 }),
            React__default.createElement("span", { "aria-hidden": "true" }, images.length)));
    }
};

export { ItemPicture };
//# sourceMappingURL=index.js.map
